import React, {useContext} from 'react';
import {Button, Dialog, DialogActions, DialogContent, DialogTitle, Zoom} from '@mui/material';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import {catalogueTransition} from '../../../services/CatalogueServices';
import {SNACKBAR_OPEN} from '../../../reducers';
import {DispatchContext, StateContext} from '../../../store';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Zoom style={{transitionDelay: '150ms'}} ref={ref} {...props}/>;
});

export default function ForwardToCurator(props) {
  const dispatch = useContext(DispatchContext);
  const {role} = useContext(StateContext);
  const {open, handleAction, catalogueId} = props;

  const onSubmit = () => {
    if (role?.id === 3) {
      catalogueTransition('put', catalogueId, {action: 'forward_to_curator'}).then(res => {
        dispatch({type: 'STATE', payload: {change: true}});
        dispatch({
          type: SNACKBAR_OPEN,
          payload: {isNotify: true, severity: 'success', message: 'Catalogue forward successfully'}
        });
        handleAction();
        window.location.reload();
      });
    } else {
      catalogueTransition('put', catalogueId, {action: 'forward_to_admin'}).then(res => {
        dispatch({type: 'STATE', payload: {change: true}});
        dispatch({
          type: SNACKBAR_OPEN,
          payload: {isNotify: true, severity: 'success', message: 'Catalogue forward successfully'}
        });
        handleAction();
        window.location.reload();
      });
    }
  }

  return (
    <div>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleAction}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle align={'center'} color={'#616B88'} sx={{fontSize: 25}} className={'text-bold'}
                     fontWeight={700}>
          Forward to {role?.id === 3 ? 'Curator' : 'Admin'}
        </DialogTitle>
        <Box className={'common-divider'}/>
        <DialogContent sx={{width: 400}}>
          <Typography>
            Are you sure you want to forward this catalogue? By confirming, you forward the catalogue to the {role?.id === 3 ? 'curator' : 'admin'}.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleAction} variant={'outlined'}
                  color={'error'} className={'text-capitalize'}>
            Cancel
          </Button>
          <Button variant={'contained'} onClick={onSubmit} className={'text-capitalize'}>Confirm</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}